import { Form, InputGroup } from "react-bootstrap";

// A labelled input with an optional range slider, used across calculators.
function CalcField({ label, value, onChange, min, max, step = 1, prefix, suffix, slider = true }) {
  const handle = (e) => {
    const v = e.target.value;
    onChange(v === "" ? "" : Number(v));
  };

  return (
    <Form.Group className="mb-4">
      <Form.Label className="fw-semibold d-flex justify-content-between">
        <span>{label}</span>
      </Form.Label>
      <InputGroup>
        {prefix && <InputGroup.Text>{prefix}</InputGroup.Text>}
        <Form.Control type="number" value={value} onChange={handle} min={min} max={max} step={step} />
        {suffix && <InputGroup.Text>{suffix}</InputGroup.Text>}
      </InputGroup>
      {slider && (
        <Form.Range
          className="mt-2"
          value={value || 0}
          onChange={handle}
          min={min}
          max={max}
          step={step}
        />
      )}
    </Form.Group>
  );
}

export default CalcField;
